module.exports = __webpack_public_path__ + "static/img/improvement_5.5f6db4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/improvement_5.png
// module id = yQAP
// module chunks = 1